module.exports = __webpack_public_path__ + "img/icon_pre-registration_management.c38a41a0.svg";